<template>
    <div class="job-role">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5">
                <h6 class="font-weight-bold mb-4 mt-5 text-left kova-text">Select skill(s) you require from your developer</h6>          

                <div class="d-flex flex-wrap text-left">
                    <div class="pl-4 py-1" style="min-width: 200px" v-for="skill in skills" :key="skill">
                        <label class="checkbox-label mb-3" style="font-size: 13px">
                            <input type="checkbox" :value="skill" v-model="devSkills"/>
                            <span class="checkbox-custom rectangular"></span><span class="mb-3 ml-4 pl-2">{{skill}}</span>
                        </label>
                    </div>
                </div>
                <h6 class="my-3 font-weight-bold kova-text text-left">How long do you need the developer to work on your project?</h6>
                <div class="text-left">
                    <label for="opt1" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt1" class="hidden" value="weeks" v-model="duration"/>
                        <span class="label"></span>1 to 4 weeks
                    </label><br />
                    
                    <label for="opt2" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt2" class="hidden" value="months" v-model="duration" />
                        <span class="label"></span>1 to 3 months
                    </label><br />
                    
                    <label for="opt3" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt3" class="hidden" value="moremonths" v-model="duration"/>
                        <span class="label"></span>3 to 6 months
                    </label><br />

                    <label for="opt4" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt4" class="hidden" value="manymonths" v-model="duration"/>
                        <span class="label"></span>Longer than 6 months
                    </label><br />
                    
                    <label for="opt5" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt5" class="hidden" value="hours" v-model="duration" />
                        <span class="label"></span>Few hours
                    </label>
                    <div class="ml-5" v-if="showInput">
                    How many hours? <input type="number" class="input" placeholder="6"/>
                    </div><br />
                    
                    <label for="opt6" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt6" class="hidden" value="not-certain" v-model="duration"/>
                        <span class="label"></span>Don't know yet
                    </label><br />
                </div>
                <h6 class="my-3 font-weight-bold kova-text text-left">How many hours of commitment will you require from your developer?</h6> 
                <div class="text-left">
                    <label for="opt1" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt1" class="hidden"/>
                        <span class="label"></span>40 or more hrs/week (Full time)
                    </label><br />

                    <label for="opt2" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt2" class="hidden"/>
                        <span class="label"></span>Less than 40 hrs/week (Part time)
                    </label><br />

                    <label for="opt3" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt3" class="hidden"/>
                        <span class="label"></span>Hourly
                    </label><br />

                    <label for="opt4" class="radio text-left" style="font-size: 13px">
                        <input type="radio" name="rdo" id="opt4" class="hidden"/>
                        <span class="label"></span>Don't know yet
                    </label><br />
                </div>            
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 rounded" style="font-size: 13px" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 rounded" style="font-size: 13px" @click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
 </div>
</template>
<script>

export default {
    name: 'job-role',
    components: {

    },
    data(){
        return {
            htmlForEditor: "",
            devSkills: [],
            skills: [
                'Android', 'IOS', 'CyberSecurity','Data Engineering', 'eCommerce', 'Web Application','Front-end',
                'Back-end', 'UI/UX', 'Artificial Intelligence', 'Blockchain', 'Integration', 'Project management',
                'DApps', 'DevOps'
            ],
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'experience'})
        },
        skip(){
            this.$router.push({path:'stack'})
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    }
}
</script>
<style scoped>

</style>
